<template>
    <SpinnerLoader v-show="loading"></SpinnerLoader>
</template>

<script>
    import {getUsernameCompany} from "../api";
    import SpinnerLoader from "../components/common/SpinnerLoader";
    import {URL_BOOKING} from "../common/constants";
    import i18n from '../i18n'

    export default {
        title: i18n.t('common.calendar'),
        name: "OldAppointmentBooking",
        components: {SpinnerLoader},
        data: () => {
            return {
                loading: false,
                username: ""
            }
        },
        async mounted() {
            this.loading = true;
            this.errorMessage = "";
            try {
                this.username = await getUsernameCompany(this.$route.params.company_id);
                this.loading = false;
                window.location = URL_BOOKING + this.username

            } catch (e) {
                this.loading = false;
            }
        },

    };
</script>
